import React, { useContext } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, Grid, TextField } from "@material-ui/core";
import { useFormik } from "formik";
import DialogTitleComponent from "../../../../components/dialog_title";
import { Agregar } from "../../../../services/request/reclutamiento/formulariosPostulacion";
import { VerificarAccesoArchivo } from "../../../../services/utilities/google_apps_scripts";
import { FormikInitialValues, FormikValidationSchema } from "./utils";
import { MainContext } from "../../../../App";

export default function DialogAdd(props) {
	const {
		is_open,
		handle_close,
		mutate_formularios_postulacion,
	} = props;

	const MainCTX = useContext(MainContext);

	const formik = useFormik({
		initialValues: FormikInitialValues,
		validationSchema: FormikValidationSchema,
		onSubmit: async (values, helper) => {
			try {
				//Se verifica acceso al archivo por parte de cydocs@cydingenieria.cl.
				let check = await VerificarAccesoArchivo(values.link_formulario);
				if (!check) {
					//Error, sin acceso al archivo.
					MainCTX.ShowSnackbar("CyDocs no tiene acceso al archivo.", new Error("Archivo sin acceso."));
				} else {
					//Se guardan los datos.
					await Agregar(values);
					MainCTX.ShowSnackbar("Formulario de postulaciones agregado exitosamente.");
				}
			} catch (error) {
				MainCTX.ShowSnackbar("Error al intentar agregar el formulario de postulaciones.", error);
			} finally {
				helper.resetForm();
				mutate_formularios_postulacion();
				handle_close();
			}
		}
	});

	return (
		<Dialog open={is_open} onClose={handle_close} maxWidth="md" PaperProps={{ style: { borderRadius: 20 } }} fullWidth>
			<DialogTitleComponent onClose={handle_close}>Agregar formulario de postulaciones</DialogTitleComponent>
			<DialogContent>
				<DialogContentText>
					{"Ingrese la información requerida del formulario de postulaciones y luego guarde los cambios."}
				</DialogContentText>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<TextField
							name="nombre"
							label="Nombre"
							onChange={formik.handleChange}
							variant="outlined"
							required
							fullWidth
							size="small"
							helperText={formik.errors.nombre}
							error={Boolean(formik.errors.nombre)}
						/>
					</Grid>
					<Grid item xs={12}>
						<TextField
							name="link_formulario"
							label="Link del formulario"
							onChange={formik.handleChange}
							variant="outlined"
							required
							fullWidth
							size="small"
							helperText={formik.errors.link_formulario}
							error={Boolean(formik.errors.link_formulario)}
						/>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={handle_close} color="primary">Cancelar</Button>
				<Button onClick={formik.submitForm} disabled={formik.isSubmitting} variant="contained" color="primary">Aceptar</Button>
			</DialogActions>
		</Dialog>
	);
}